export default {"src":"/_next/static/media/tiktok.b66faea5.svg","height":36,"width":37,"blurWidth":0,"blurHeight":0};